import type { RenderDraftStateDto } from '@app/shared';
import { useT } from '../i18n';
import { lookLine, variantOf, type Look } from '../lib/format-text';
import { Button } from './ui';

/**
 * With text, the choice folds into one line above it (spec 4.4): the style's
 * picture, «Рилс · Подборка · Стекло» and «Сменить», which opens the example
 * and the chips again.
 */
export function LookSummary({
  state,
  look,
  disabled,
  onChange,
}: {
  state: RenderDraftStateDto;
  look: Look;
  disabled: boolean;
  onChange: () => void;
}) {
  const t = useT();
  const style = variantOf(state, look.kind)?.styles.find((s) => s.id === look.style) ?? null;
  return (
    <div className="flex items-center gap-3 rounded-2xl bg-surface shadow-card p-2 pr-3 mb-4">
      <div
        className={
          look.kind === 'carousel'
            ? 'w-10 aspect-[4/5] rounded-lg overflow-hidden bg-surface-2 flex-shrink-0'
            : 'w-9 aspect-[9/16] rounded-lg overflow-hidden bg-surface-2 flex-shrink-0'
        }
      >
        {style?.previewUrl ? (
          <img src={style.previewUrl} alt="" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full" style={{ backgroundColor: style?.accent }} />
        )}
      </div>
      <span className="text-sm font-semibold min-w-0 flex-1 break-words">{lookLine(state, look, t)}</span>
      <Button variant="secondary" size="sm" disabled={disabled} onClick={onChange}>
        {t.formatText.change}
      </Button>
    </div>
  );
}
